import MenuAside from './app/menu.aside'
import { isPositionStickySupported } from './utils';

function init()
{
	new MenuAside();

	if (!isPositionStickySupported())
	{
		if (window.Sticky)
			new Sticky('.kt-portlet__head--is-sticky', {
				wrap: true
			});
	}

	const dtItems = [...document.body.querySelectorAll('.dropdown-toggle')];
	dtItems && dtItems.forEach(item => {
		var angle = item.querySelector('.dropdown-toggle-angle');

		if (angle)
			return;

		angle = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
		angle.classList.add('icon-svg', 'dropdown-toggle-angle');
		angle.innerHTML = '<use xlink:href="' + (BX.message.SITE_DIR || '/') + 'include/sprite.svg#angle-small-down"></use>';

		item.appendChild(angle);
	});
}

// page on ready
function onReady()
{
	init()
}

// composite data recieved
function onFrameDataReceived(json = {})
{
	if (!(json.dynamicBlocks || []).length)
	{
		return
	}

    init()
}

$(window).ready(onReady)
if (window.frameCacheVars !== undefined)
{
	BX.addCustomEvent("onFrameDataReceived", (json) => onFrameDataReceived(json))
}
